import React from 'react';
import { Crumple } from './Crumple';
import  texts from './data.js';

const CrumpleCanvas = () => {
    return (
      <div style={{
        width: '100%',
        height: '100%',
        cursor: 'none',
      }}>
  
        <Crumple
          content={{
            justification: 'center',
            fontSize: 100, 
          }}
          bend={50}
          strokeWidth={20}
          documentBackgroundColor='blue'
          count={50}
          texts ={texts[0]}
        />
  
  
        <Crumple
          strokeWidth={25}
          crumpleX={20}
          colors={['blue']}
          documentBackgroundColor='black'
          content={{
            justification: 'center',
            fontSize: 100,
          }}
          texts = {texts[1]}
        />
  
        <Crumple
          strokeWidth={70}
          colors={[
            'black',
          ]}
          documentBackgroundColor='red'
          fillColor='white'
          content={{
            justification: 'center',
            fontSize: 300, 
          }}
          texts = {texts[2]}
        />
  
        <Crumple
          strokeWidth={100}
          colors={[
            'red',
          ]}
          content={{
            justification: 'center',
            fontSize: 100, 
          }}
          bend={-100}
          texts = {texts[3]}
        />  
{/*   
        <Crumple
          strokeWidth={1}
          bend={-100}
          fillColor='black'
          colors={['black']}
          documentBackgroundColor='white'
          text={'Hidden Away'}
          crumpleY={10}
          content={{
            justification: 'center',
            fontSize: 200, 
          }}
          texts = {[
            {
              text: 'Look Again',
              count: 200,
              fontSize: 200,
            },
            {
              text: 'Yes',
              count: 300,
              fontSize: 400,
            },
            {
              text: 'I\'m here',
              count: 400,
              fontSize: 200,
            },
            {
              text: 'I See You',
              count: 500,
              fontSize: 100,
            },
            {
              text: 'Thank you',
              count: 600,
              fontSize: 20,
            },
          ]}
        /> */}
      </div>
    );
  };
  
  
  export default CrumpleCanvas;